import React, { useState } from "react";
import mockup from "../images/mockup.png";

function FirstSlide(props) {

return (
<div className="main-modern">
  {/* Hero Section */}
  <div className="hero-section">
    <div className="hero-content">
      <h1 className="hero-title">
        Управляйте своей футбольной лигой 
        <span className="hero-title-gradient"> профессионально</span>
      </h1>
      <p className="hero-subtitle">
        Полный контроль над матчами, статистикой и заявками в режиме реального времени. 
        Все инструменты для администрирования лиги в одном месте.
      </p>
      <div className="hero-features">
        <div className="hero-feature-item">
          <div className="hero-feature-icon">⚡</div>
          <span>Быстрое внесение результатов</span>
        </div>
        <div className="hero-feature-item">
          <div className="hero-feature-icon">📊</div>
          <span>Автоматическая статистика</span>
        </div>
        <div className="hero-feature-item">
          <div className="hero-feature-icon">📱</div>
          <span>Работа с любого устройства</span>
        </div>
      </div>
    </div>
    <div className="hero-image">
      <div className="phone-mockup-wrapper">
        <img src={mockup} className="phone-mockup" alt="inGame App"/>
        <div className="mockup-glow"></div>
      </div>
    </div>
  </div>

  {/* Features Section */}
  <div className="features-section">
    <h2 className="section-title">Ключевые возможности</h2>
    <div className="features-grid">
      <div className="feature-card">
        <div className="feature-icon">🎯</div>
        <h3>Управление матчами</h3>
        <p>Создавайте матчи, назначайте судей и стадионы, вносите результаты в реальном времени</p>
      </div>
      <div className="feature-card">
        <div className="feature-icon">👥</div>
        <h3>Управление заявками</h3>
        <p>Просматривайте и управляйте заявками команд, добавляйте и исключайте игроков</p>
      </div>
      <div className="feature-card">
        <div className="feature-icon">📈</div>
        <h3>Статистика и отчеты</h3>
        <p>Полная статистика по игрокам, командам и матчам обновляется автоматически</p>
      </div>
    </div>
  </div>

  {/* Stats Section */}
  <div className="stats-section">
    <div className="stats-grid">
      <div className="stat-item">
        <div className="stat-number">217</div>
        <div className="stat-label">Активных лиг</div>
      </div>
      <div className="stat-item">
        <div className="stat-number">92</div>
        <div className="stat-label">Города России</div>
      </div>
      <div className="stat-item">
        <div className="stat-number">&gt;200K</div>
        <div className="stat-label">Футболистов</div>
      </div>
      <div className="stat-item">
        <div className="stat-number">&gt;100K</div>
        <div className="stat-label">Проведено матчей</div>
      </div>
    </div>
  </div>

  {/* CTA Section */}
  <div className="cta-section">
    <h2 className="cta-title">Готовы начать работу?</h2>
    <p className="cta-subtitle">Получите полный доступ к инструментам администрирования вашей лиги</p>
    <a href="https://vk.com/ingame_app" target="_blank" rel="noopener noreferrer" className="vk-link">
      <div className="vk-button">
        <svg className="vk-icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
          <path d="M25.26 32.87h1.97s.6-.06.9-.38c.28-.3.27-.85.27-.85s-.04-2.6 1.16-2.98c1.18-.37 2.69 2.51 4.29 3.62 1.21.84 2.13.66 2.13.66l4.27-.06s2.23-.14.98-1.9c-.1-.17-.72-1.53-3.72-4.33-3.13-2.93-2.71-2.45.97-7.52 2.24-3.08 3.14-4.96 2.86-5.77-.27-.77-1.93-.57-1.93-.57l-4.81.03s-.36-.05-.62.11c-.26.16-.42.53-.42.53s-.76 2.03-1.77 3.76c-2.14 3.65-3 3.84-3.35 3.61-.81-.53-.61-2.13-.61-3.27 0-3.55.54-5.03-1.04-5.41-.53-.13-.92-.21-2.27-.23-1.73-.02-3.19.01-4.02.41-.55.27-.97.87-.71.9.32.04 1.05.2 1.44.73.5.68.48 2.21.48 2.21s.29 4.19-.67 4.71c-.66.36-1.56-.37-3.5-3.7-.99-1.69-1.74-3.56-1.74-3.56s-.14-.36-.4-.55c-.31-.23-.74-.3-.74-.3l-4.57.03s-.69.02-.94.32c-.22.27-.02.82-.02.82s3.58 8.39 7.63 12.62c3.71 3.88 7.92 3.63 7.92 3.63z"/>
        </svg>
        <span>Присоединяйтесь к нашему сообществу</span>
      </div>
    </a>
  </div>
</div>
  );
}

export default FirstSlide;

